import { Measure } from 'services/model/model.service';
import { DataEntry } from 'models/data';

export const extractTenantValue = (improvementMeasure: Measure, currentItem: DataEntry) =>
  improvementMeasure.getValue(currentItem.values);
export const extractPeerValue = (improvementMeasure: Measure, currentItem: DataEntry, selectedBenchmark: string) =>
  improvementMeasure.getValue(currentItem.benchmarks?.[selectedBenchmark].values);

export const extractTenantCompareValue = (improvementMeasure: Measure, currentItem: DataEntry) =>
  improvementMeasure.getValue(currentItem.compareValues);
export const extractPeerCompareValue = (
  improvementMeasure: Measure,
  currentItem: DataEntry,
  selectedBenchmark: string
) => improvementMeasure.getValue(currentItem.benchmarks?.[selectedBenchmark].compareValues);

export const extractTenantGrowthValue = (improvementMeasure: Measure, currentItem: DataEntry) =>
  improvementMeasure.getValue(currentItem.values) / improvementMeasure.getValue(currentItem.compareValues) - 1;

export const extractPeerGrowthValue = (
  improvementMeasure: Measure,
  currentItem: DataEntry,
  selectedBenchmark: string
) =>
  improvementMeasure.getValue(currentItem.benchmarks?.[selectedBenchmark].values) /
    improvementMeasure.getValue(currentItem.benchmarks?.[selectedBenchmark].compareValues) -
  1;

export interface TopOpportunityGapCalculatorParams {
  improvementMeasure: Measure;
  currentItem: DataEntry;
  selectedBenchmark: string;
}

export type TopOpportunityGapCalculator = (params: TopOpportunityGapCalculatorParams) => number;

export const calculatePerformanceGap: TopOpportunityGapCalculator = ({
  improvementMeasure,
  currentItem,
  selectedBenchmark,
}) => {
  const tenantValue = extractTenantValue(improvementMeasure, currentItem) ?? 0;
  const tenantCompareValue = extractTenantCompareValue(improvementMeasure, currentItem);

  const benchmarkValue = extractPeerValue(improvementMeasure, currentItem, selectedBenchmark) ?? 0;
  const benchmarkCompareValue = extractPeerCompareValue(improvementMeasure, currentItem, selectedBenchmark);

  const benchmarkGrowth = benchmarkValue / (benchmarkCompareValue ?? 1) - 1;
  const gap = tenantValue / ((tenantCompareValue ?? 0) * (1 + benchmarkGrowth) || 1) - 1;

  return Number.isFinite(gap) ? gap : 0;
};
